import React from "react";
import PropTypes from "prop-types";
import Icon from "./icon-share.svg";

const ShareButton = ({ toggleShare }) => (
  <button className="mr-3" onClick={() => toggleShare()}>
    <img src={Icon} alt="Share Icon" data-id="shareIcon" title="Share Photo" />
  </button>
);

ShareButton.propTypes = {
  toggleShare: PropTypes.func.isRequired,
};

export default ShareButton;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/ShareButton/index.jsx